import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pt-[0.12em] -mt-[0.12em] pb-[0.08em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "105%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.001, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);
